import { Injectable } from '@angular/core'
import { ActiveLiveStreamLocation } from '@ftr/contracts/regional-api'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult, mapData } from '@ftr/foundation'
import { plainToClass } from '@ftr/serialization'
import { switchMap } from 'rxjs'
import { RegionalApiClientFactory, RegionalApiClientSetupService } from '../../api-client'

@Injectable({
  providedIn: 'root',
})
export class LiveStreamingLocationsService extends RegionalApiClientSetupService {
  constructor(apiClientFactory: RegionalApiClientFactory) {
    super(apiClientFactory)
  }

  getActiveLocations(courtSystemId: Uuid): ApiResult<ActiveLiveStreamLocation[]> {
    return this.regionalApiClient('/live-stream/location/active', courtSystemId).pipe(
      switchMap(client => client.get<ActiveLiveStreamLocation[]>({ headers: { courtSystemId } })),
      mapData(x => plainToClass(ActiveLiveStreamLocation, x)),
    )
  }
}
